import { render, staticRenderFns } from "./PhotoBlock.vue?vue&type=template&id=fdaedcc6&scoped=true&"
import script from "./PhotoBlock.vue?vue&type=script&lang=js&"
export * from "./PhotoBlock.vue?vue&type=script&lang=js&"
import style0 from "./PhotoBlock.vue?vue&type=style&index=0&id=fdaedcc6&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdaedcc6",
  null
  
)

export default component.exports